import React, { Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { authenticateUser, setError } from "./../../redux/actions/authActions";
import { Auth_ERRORS } from "./../../redux/middleware/constants";
const AuthRoutes = ({ children, actions }) => {
  // even if we refresh...error will be there in loaclstorage
  const error = localStorage.getItem("error");
  if (error) {
    console.log(error, " from localstorage ");
    for (let err of Object.values(Auth_ERRORS)) {
      if (err.errorTitle === error) {
        actions.setError(err);
      }
    }
  } else actions.authenticateUser();
  return <Fragment>{children}</Fragment>;
};
const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ authenticateUser, setError }, dispatch)
  };
};

export default connect(
  null,
  mapDispatchToProps
)(AuthRoutes);



// WEBPACK FOOTER //
// ./src/components/common/AuthRoutes.js